import axios from 'axios';
// import qs from 'qs';

// 查询收货地址列表
export function getAddressList(params) {
  return axios({
    url: '/mall/app/shipping_address',
    method: 'get',
    params,
  });
}
//查询默认收货地址
export function getDefaultAddress(params) {
  return axios({
    url: '/mall/app/shipping_address/default',
    method: 'get',
    params,
  });
}
//更新收货地址
export function upChangeData(data) {
  return axios({
    url: '/mall/app/shipping_address',
    method: 'put',
    data: data,
  });
}
//设为默认收货地址
export function setDefaultAddress(data) {
  return axios({
    url: '/mall/app/shipping_address/' + data,
    method: 'put',
    data: data,
  });
}
//删除收货地址
export function deleteAddress(params) {
  return axios({
    url: '/mall/app/shipping_address/' + params,
    method: 'delete',
  });
}
//添加收获地址
export function addReceiving(data) {
  return axios({
    url: `/mall/app/shipping_address`,
    method: 'post',
    data: data,
  });
}
